export default __webpack_public_path__ + "static/media/construction.6d336d3c.jpg";